
const Run = ({ run, onSelect }) => {
    return (
        <div class='run' onClick={() => onSelect(run.id)}>
            <div>
                <h3>{run.player}</h3>
            </div>
            <div>
                <p> {run.players}</p>
            </div>
            
        </div>
    )
}

export default Run